import { css } from "emotion";

const Image = ({
  src,
  alt = "",
  objectFit = "contain",
  className = undefined
}) => {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{ objectFit: objectFit }}
    />
  );
};

export default Image;
